module.exports = __webpack_public_path__ + "img/cz-partners-aktualne.95f152d1.png";